// extracted by mini-css-extract-plugin
export default {"grid":"ProjectThumbnailsV3Grid_grid__UsIOj"};